// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac54da6a","239":"4de536a3","453":"ebec51f7","732":"3ccbf2fe"}[chunkId] + ".chunk.js";
};